import CatalogService from "../services/catalog/CatalogService";
import CustomerService from "../services/customer/CustomerService";
import WebsiteInfoService from "../services/websiteInfo/websiteInfoService";
import ImageService from "../services/image/ImageService";
import KeywordService from "../services/customer/KeywordService";
import {
    SELECTED_DATA_TABLE,
    ADD_RECORD_TO_WATCHLIST,
    CHECK_TOKEN,
    GET_CATALOG,
    GET_WATCHLIST_LIST,
    REMOVE_RECORD_FROM_WATCHLIST,
    ROUTER_PUSH,
    SET_DIALOG_COMPONENT,
    SET_DIALOG_SETTINGS,
    SHOW_TOAST_MESSAGE,
    SWITCH_DIALOG,
    GET_WEBSITE_INFO,
    GET_IMAGES,
    GET_SLUGS,
    GET_WEBSITE_TEXT,
    GET_LEGAL_TEXT,
    GET_EVENTS_LENGTH,
    ADD_KEYWORDS,
    SET_COUNTRY,
    SET_COUNTRY_STATE_CITY,
    SET_API_COUNTRIES,
    SET_STATES_BY_COUNTRIES,
    SET_STATES_BY_COUNTRY,
    SET_CITIES_BY_STATES
} from "./actions";
import phoneCodes from "./phoneCodes";
import SlugService from "../services/slug/SlugService";
import WebsiteTextService from "../services/websiteText/WebsiteText";
import LegalsService from "../services/legals/LegalsService";
import EventService from "../services/event/EventService";
import { SET_DEFAULT_LANGUAGE_AND_CURRENCY } from "./action";
import CountryStateCityService from "../services/countryStateCity/CountryStateCityService";


export default {
    state: {
        defaultLanguageAndCurrency:{
            "currency": {
                "id": 1,
                "name": "US Dollar",
                "code": "USD",
                "symbol": "$",
                "rate": 1,
                "created_at": null,
                "updated_at": "2024-09-16T08:00:12.000000Z",
                "flag": null
            },
            "language": {
                "code": "en",
                "name": "English",
                "flag": null
            },
            "country_name": "Lebanon"

        },
        country:"France",
        brands: [],
        slugs:[],
        website_text:{},
        categories: [],
        products: [],
        conditions: [],
        productTypes: [],
        phoneCodes: phoneCodes,
        showDialog: false,
        dialogComponent: undefined,
        dialogSettings: {},
        watchlistList: {},
        toast: undefined,
        router: undefined,
        document: undefined,
        selectedDataTDataTable: { value: [] },
        websiteInfo: {},
        images:{},
        legalText:{},
        eventsLength: undefined,
        keywords:{
            preferences:[]
            // keyword:[],
            // categories:[],
            // brands:[],
            // kits:[]
        },
        apiCountries:[],
        statesByCountry: [],
        citiesbyState: [], 
    },

    getters: {
        defaultLanguageAndCurrency: (state)=> state.defaultLanguageAndCurrency,
        country: (state) => state.country,
        legalText: (state) => state.legalText,
        slugs: (state) => state.slugs,
        website_text: (state) => state.website_text,
        brands: (state) => state.brands,
        selectedDataTDataTable: (state) => state.selectedDataTDataTable,
        categories: (state) => state.categories,
        products: (state) => state.products,
        conditions: (state) => state.conditions,
        phoneCodes: (state) => state.phoneCodes,
        showDialog: (state) => state.showDialog,
        dialogComponent: (state) => state.dialogComponent,
        dialogSettings: (state) => state.dialogSettings,
        watchlistList: (state) => state.watchlistList,
        getToast: (state) => state.toast,
        getRouter: (state) => state.getRouter,
        getDocument: (state) => state.document,
        productTypes: (state) => state.productTypes,
        websiteInfo: (state) => state.websiteInfo,
        images: (state) => state.images,
        eventsLength: (state) => state.eventsLength,
        keywords:(state) =>state.keywords,
        apiCountries: (state) => state.apiCountries,
        statesByCountry: (state) => state.statesByCountry,
        citiesbyState: (state) => state.citiesbyState,
    },

    mutations: {
        [SET_DEFAULT_LANGUAGE_AND_CURRENCY]:(state, data)=>{
            state.defaultLanguageAndCurrency = data;
        },
        [SET_COUNTRY]: (state, data)=>{
            state.country = data;
        },
        [GET_LEGAL_TEXT]: (state, data)=>{
            state.legalText = data;
        },
        [GET_EVENTS_LENGTH]: (state, data)=>{
            state.eventsLength = data
        },
        [GET_WEBSITE_INFO]: (state, data)=>{
            state.websiteInfo = data;
        },
        [GET_WEBSITE_TEXT]: (state, data)=>{
            state.website_text = data;
        },
        [GET_SLUGS]: (state, data)=>{
            state.slugs = data;
        },
        [SELECTED_DATA_TABLE]: (state, data) => {
            state.selectedDataTDataTable = data;
        },
        [GET_CATALOG]: (state, catalog) => {
            state.brands = catalog.brands;
            state.categories = catalog.categories;
            state.conditions = catalog.conditions;
            state.products = catalog.products;
            state.productTypes = catalog.productTypes;
        },
        [SWITCH_DIALOG]: (state) => {
            state.showDialog = !state.showDialog;
        },
        [SET_DIALOG_COMPONENT]: (state, component) => {
            state.dialogComponent = component;
        },
        [SET_DIALOG_SETTINGS]: (state, settings) => {
            state.dialogSettings = settings;
        },
        [GET_WATCHLIST_LIST]: (state, data) => {
            var obj = {};
            if (data != undefined) {
                data.forEach((element) => {
                    obj[element.id] = element;
                });
            }
            state.watchlistList = obj;
        },
        [ADD_RECORD_TO_WATCHLIST]: (state, data) => {
            state.watchlistList[data.id] = data;
        },
        [REMOVE_RECORD_FROM_WATCHLIST]: (state, kitId) => {
            delete state.watchlistList[kitId];
        },
        [GET_IMAGES]: (state, images) => {
            state.images = images
        },
        setToast: (state, toast) => {
            state.toast = toast;
        },
        setRouter: (state, router) => {
            state.router = router;
        },
        setDocument: (state, document) => {
            state.document = document;
        },
        setApiCountries: (state, apiCountries) => {
            state.apiCountries = apiCountries;
        },
        setStatesByCountry: (state, states) => {
            state.statesByCountry = states;
        },
        setCitiesbyState: (state, cities) => {
            state.citiesbyState = cities;
        },
        

    },

    actions: {
        [SET_API_COUNTRIES]: async(context) => {
            var countryStateCityService = new CountryStateCityService();
            var countries = await countryStateCityService.fetchCountries();
            
            context.commit('setApiCountries', countries);
        },
         
        [SET_STATES_BY_COUNTRY]: async(context, countryCode) => {
            var countryStateCityService = new CountryStateCityService();
            var states = await countryStateCityService.fetchStatesByCountry(countryCode);
            
            context.commit('setStatesByCountry', states);   
        },

        [SET_CITIES_BY_STATES]: async(context, { countryCode, stateCode }) => {
            var countryStateCityService = new CountryStateCityService();    
            var cities = await countryStateCityService.fetchCitiesByState(countryCode, stateCode);
               
            context.commit('setCitiesbyState', cities);
        },
        

        [CHECK_TOKEN]: async(context) => {
            var customerService = new CustomerService();
            var data = await customerService.checkToken();
            return data;
        },

        [SET_DEFAULT_LANGUAGE_AND_CURRENCY]: async(context) => {
            try{
                let customerService = new CustomerService()
                let defaut_language_and_currency = await customerService.getDefaultLanguageAndCurrency()
                context.commit(SET_COUNTRY, defaut_language_and_currency['country_name'])
                context.commit(SET_DEFAULT_LANGUAGE_AND_CURRENCY, defaut_language_and_currency)   
            }
            catch{}
        },

        [GET_EVENTS_LENGTH]: async(context) => {
            var eventService = new EventService();
            var res = await eventService.getEventsLength();
            context.commit(GET_EVENTS_LENGTH,res.data);
            return res.data;
        },

        [SHOW_TOAST_MESSAGE]: (context, message) => {
            if (message.life == undefined) message.life = 120000;
            context.state.toast.add({
                severity: message.severity,
                summary: message.summary,
                detail: message.detail,
                life: message.life,
            });
        },
        [ROUTER_PUSH]: (context, name) => {
            context.state.router.push({ name: name });
        },
        [GET_WATCHLIST_LIST]: async(context) => {
            var customerService = new CustomerService();
            var result = await customerService.getCustomerWathclist(
                context.getters.customer.id
            );
            context.commit(GET_WATCHLIST_LIST, result.data.data);
            return result;
        },

        [GET_LEGAL_TEXT]: async(context) => {
            var legalService = new LegalsService();
            var result = await legalService.getAll();
            context.commit(GET_LEGAL_TEXT, result.data.data);
            return result;
        },
        [GET_WEBSITE_INFO]: async(context) => {
            var websiteInfoService = new WebsiteInfoService();
            var result = await websiteInfoService.getAll();

            context.commit(GET_WEBSITE_INFO, result.data);
            return result;
        },

        [GET_WEBSITE_TEXT]: async(context) => {
            var websiteText = new WebsiteTextService();
            var result = await websiteText.getAll();

            context.commit(GET_WEBSITE_TEXT, result.data);
            return result;
        },

        [GET_SLUGS]: async(context) => {
            var slugService = new SlugService();
            var result = await slugService.getAll();

            context.commit(GET_SLUGS, result.data);
            return result;
        },

        [GET_IMAGES]: async(context) => {
            var imageService = new ImageService();
            var result = await imageService.getAll();
            context.commit(GET_IMAGES, result.data);
            return result;
        },
        [GET_CATALOG]: async({ commit }) => {
            var catalogService = new CatalogService();
            var catalog = await catalogService.get();
            commit(GET_CATALOG, catalog);
            return catalog;
        },
        [SWITCH_DIALOG]: async(context) => {
            context.commit(SWITCH_DIALOG);
        },
        [SET_DIALOG_COMPONENT]: (context, component) => {
            context.commit(SET_DIALOG_COMPONENT, component);
        },
        [SET_DIALOG_SETTINGS]: (context, settings) => {
            context.commit(SET_DIALOG_SETTINGS, settings);
        },
        [ADD_KEYWORDS]:async (context, data) => {
            var keywordService = new KeywordService();
            if(context.getters.isAuthenticated)
            {
                await keywordService.setkeywords(data);
            }
            else
            {
                await keywordService.setkeywordsUnAuthenticated(data)
            }


        }
    },
};